export default __webpack_public_path__ + "static/media/fortune white 1.d4bad699.svg";